import { ThemeProvider, useTheme as emotionUseTheme } from '@emotion/react';
import { Theme } from './types';

type useTypedTheme = () => Theme;
const useTheme = emotionUseTheme as useTypedTheme;

export { ThemeProvider, useTheme };
